import styled from "styled-components";

export const TopPadding = styled.div`
  padding-top: 16px;
`;
